import React, { useEffect, useRef, useState } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './index.css';

function ProductSlider({ images, videos, variant = 'default' }) {
    const isProfileFigma = variant === 'profile-figma';
    const [nav1, setNav1] = useState(null);
    const [nav2, setNav2] = useState(null);
    let sliderRef1 = useRef(null);
    let sliderRef2 = useRef(null);

    useEffect(() => {
        setNav1(sliderRef1);
        setNav2(sliderRef2);
    }, []);

    const thumbSettings = isProfileFigma
        ? {
            vertical: false,
            infinite: false,
            slidesToShow: 5,
        }
        : {
            vertical: true,
            infinite: true,
            loop: true,
            slidesToShow: 3,
        };

    return (
        <div className={`slider-container ${isProfileFigma ? 'profile-figma-slider' : ''} ${videos ? 'has-videos' : ''}`}>
            <div className="bg-product-slider">
                <Slider dots={false} arrows={false} asNavFor={nav2} ref={slider => (sliderRef1 = slider)}>
                    {images && (
                        images?.map((item, index) => (
                            <div key={index}>
                                <div className="product-details-img position-relative">
                                    <img src={item.path} alt="" className="img-fluid" />
                                </div>
                            </div>
                        ))
                    )}
                    {videos && (
                        videos?.map((item, index) => (
                            <div key={index}>
                                <div className="product-details-img position-relative">
                                    <video src={item.path} alt="" className="img-fluid" />
                                </div>
                            </div>
                        ))
                    )}
                </Slider>
            </div>
            <div className="sm-product-slider">
                <Slider
                    vertical={thumbSettings.vertical}
                    infinite={thumbSettings.infinite}
                    asNavFor={nav1}
                    ref={slider => (sliderRef2 = slider)}
                    slidesToShow={thumbSettings.slidesToShow}
                    swipeToSlide={true}
                    focusOnSelect={true}
                    arrows={false}
                >
                    {images && (
                        images?.map((item, index) => (
                            <div key={index} className="w-100 mt-3 px-2">
                                <div className="product-details-img-sm">
                                    <img src={item.path} alt="" className="img-fluid" />
                                </div>
                            </div>
                        ))
                    )}
                    {videos && (
                        videos?.map((item, index) => (
                            <div key={index} className="w-100 mt-3 px-2">
                                <div className="product-details-img-sm">
                                    <video src={item.path} alt="" className="img-fluid" />
                                </div>
                            </div>
                        ))
                    )}
                </Slider>
            </div>
        </div>
    );
}

export default ProductSlider;
